import isEmpty from './isEmpty.js'
//---------------------------------------
// convert add runecasting skill actions
//---------------------------------------
export default function convertAddRunecastingSkillActions(changed_skills) {
  //--------------------------------------------------------------------------------
  // need to convert ADD action to UPDATE action as corresponding runecasting skill
  // will be created automatically in backend following creation of new
  // integrated character-rune. id will be retrieved from backend when rune
  // created and updated in use update.
  //--------------------------------------------------------------------------------
  if (isEmpty(changed_skills)) {
    return []
  }
  //-----------------
  // convert actions
  //-----------------
  const converted = changed_skills
    .map((r) => {
      if (r.name.endsWith('Rune') && r.action === 'ADD') {
        //---------------------------------------------------------------------------------
        // if ticks & training = zero - remove entry (as same as skill created in backend)
        //---------------------------------------------------------------------------------
        if (r.payload.ticks === 0 && r.payload.training === 0) {
          return null
        }
        //----------------------------
        // else convert ADD to UPDATE
        //----------------------------
        return {
          action: 'UPDATE',
          id: null, // will be retrieved from backend when rune created
          name: r.name, // rune name
          payload: {
            ticks: r.payload.ticks,
            training: r.payload.training,
          },
        }
      }
      return r
    })
    //---------------------
    // remove null entries
    //---------------------
    .filter((r) => r !== null)
  //------------------------
  // return converted array
  //------------------------
  return converted
}
